
// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { selectUser, setUser, setGoogleUser } from '../Commonlibs/userSlice';
// import {
//   Box,
//   useMediaQuery,
//   useTheme,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Typography,
//   InputAdornment,
//   CircularProgress,
// } from '@mui/material';
// import { Phone, Email, Person } from '@mui/icons-material';
// import Sidebar from '../Seller/Sidebar';
// import PropertyDashboard from '../Seller/PropertyDashboard';
// import EditProperties from '../Seller/EditProperties';
// import ProfileInbox from '../Commonlibs/ProfileInbox';
// import Transactions from '../Seller/Transactions';
// import PropertySeeAll from './PropertySeeAll';

// const SellerProperties = () => {
//   const { propertyId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const user = useSelector(selectUser);
//   const propertyFromState = location.state?.property;
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const [currentView, setCurrentView] = useState(() => {
//     if (propertyId) return 'edit';
//     if (location.pathname.includes('/inbox')) return 'inbox';
//     if (location.pathname.includes('/transactions')) return 'transactions';
//     if (location.pathname.includes('/seeAll')) return 'seeAll';
//     return 'dashboard';
//   });

//   const [selectedProperty, setSelectedProperty] = useState(propertyFromState || null);

//   // ✅ Profile verification states
//   const [profileData, setProfileData] = useState(null);
//   const [loadingProfile, setLoadingProfile] = useState(true);
//   const [showVerificationDialog, setShowVerificationDialog] = useState(false);
//   const [verificationForm, setVerificationForm] = useState({
//     fullName: '',
//     email: '',
//     contactNumber: '',
//   });
//   const [verificationErrors, setVerificationErrors] = useState({});
//   const [verificationLoading, setVerificationLoading] = useState(false);

//   // ✅ Add refs to prevent multiple fetches and flickering
//   const profileFetchedRef = useRef(false);
//   const verificationCheckedRef = useRef(false);

//   // ✅ Fetch user profile on mount
//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       const userId = user?.id;
      
//       // Prevent multiple fetches
//       if (!userId || profileFetchedRef.current) {
//         setLoadingProfile(false);
//         return;
//       }

//       try {
//         setLoadingProfile(true);
//         profileFetchedRef.current = true; // Mark as fetched
        
//         const response = await fetch(
//           `https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`
//         );
//         const data = await response.json();

//         if (data.status === "SUCCESS") {
//           setProfileData(data.result);

//           // ✅ Check if profile needs verification (only once)
//           if (!verificationCheckedRef.current) {
//             verificationCheckedRef.current = true;
            
//             const needsVerification =
//               !data.result.full_name ||
//               data.result.full_name === 'N/A' ||
//               data.result.full_name.trim() === '' ||
//               !data.result.email_id ||
//               data.result.email_id === 'N/A' ||
//               data.result.email_id.trim() === '' ||
//               !data.result.contact_number ||
//               data.result.contact_number === 'N/A' ||
//               data.result.contact_number.trim() === '';

//             if (needsVerification) {
//               setVerificationForm({
//                 fullName: data.result.full_name && data.result.full_name !== 'N/A' ? data.result.full_name : '',
//                 email: data.result.email_id && data.result.email_id !== 'N/A' ? data.result.email_id : '',
//                 contactNumber: data.result.contact_number && data.result.contact_number !== 'N/A' ? data.result.contact_number : '',
//               });
              
//               // Use setTimeout to ensure smooth dialog opening
//               setTimeout(() => {
//                 setShowVerificationDialog(true);
//               }, 100);
//             }
//           }
//         }
//       } catch (err) {
//         console.error('Error fetching profile:', err);
//         profileFetchedRef.current = false; // Reset on error
//       } finally {
//         setLoadingProfile(false);
//       }
//     };

//     fetchUserProfile();
//   }, [user?.id]);

//   // ✅ Validation function
//   const validateVerificationField = (name, value) => {
//     if (!value || value.trim() === '' || value === 'N/A') {
//       return `${name} is required`;
//     }

//     switch (name) {
//       case 'fullName':
//         return /^[A-Za-z\s]{2,50}$/.test(value)
//           ? ''
//           : 'Name should contain only letters and spaces (2-50 characters)';
//       case 'email':
//         return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
//           ? ''
//           : 'Please enter a valid email address';
//       case 'contactNumber':
//         return /^\d{10}$/.test(value)
//           ? ''
//           : 'Phone number should be 10 digits';
//       default:
//         return '';
//     }
//   };

//   // ✅ Handle verification form changes
//   const handleVerificationChange = (field, value) => {
//     setVerificationForm(prev => ({ ...prev, [field]: value }));
//     if (verificationErrors[field]) {
//       setVerificationErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   // ✅ Handle phone number input (only digits)
//   const handlePhoneNumberChange = (e) => {
//     const value = e.target.value;
//     if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
//       handleVerificationChange('contactNumber', value);
//     }
//   };

//   // ✅ Update user profile
//   const updateUserProfile = async () => {
//     setVerificationLoading(true);
//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append('user_id', user?.id);
//       formDataToSend.append('full_name', verificationForm.fullName);
//       formDataToSend.append('email_id', verificationForm.email);
//       formDataToSend.append('contact_number', verificationForm.contactNumber);

//       const response = await fetch('https://propertydealstalk.com/api/users/UpdateUserprofile', {
//         method: 'POST',
//         body: formDataToSend,
//       });

//       const data = await response.json();

//       if (data.status === "SUCCESS") {
//         setProfileData(data.result);
        
//         // Close dialog smoothly
//         setShowVerificationDialog(false);

//         // Update Redux with complete user details
//         const updatedUser = {
//           id: data.result.id,
//           fullName: data.result.full_name,
//           email: data.result.email_id,
//           contactNumber: data.result.contact_number,
//           token: user?.token,
//           authProvider: data.result.auth_provider,
//           googleId: data.result.google_id,
//           profileImage: data.result.profile_image,
//         };

//         // Update localStorage
//         localStorage.setItem('user_name', data.result.full_name);
//         localStorage.setItem('user_email', data.result.email_id);

//         // Dispatch to Redux
//         if (data.result.auth_provider === 'google') {
//           dispatch(setGoogleUser(updatedUser));
//         } else {
//           dispatch(setUser(updatedUser));
//         }
//       } else {
//         alert(data.message || 'Failed to update profile');
//       }
//     } catch (error) {
//       console.error('Profile update error:', error);
//       alert('Failed to update profile. Please try again.');
//     } finally {
//       setVerificationLoading(false);
//     }
//   };

//   // ✅ Handle verification submit
//   const handleVerificationSubmit = async () => {
//     const newErrors = {};
//     Object.keys(verificationForm).forEach(key => {
//       const error = validateVerificationField(key, verificationForm[key]);
//       if (error) newErrors[key] = error;
//     });

//     if (Object.keys(newErrors).length > 0) {
//       setVerificationErrors(newErrors);
//       return;
//     }

//     await updateUserProfile();
//   };

//   // Existing property management logic
//   useEffect(() => {
//     if (propertyId) {
//       if (!selectedProperty || selectedProperty.id !== parseInt(propertyId)) {
//         const fetchProperty = async () => {
//           try {
//             const mockProperty = {
//               id: parseInt(propertyId),
//               price: '₹250,000.00',
//               title: 'Modern Luxury Villa with Ocean View',
//               location: 'Nanakram guda, Hyderabad, India',
//               date: 'May 13, 2025',
//               views: '2,500 Views',
//               beds: 4,
//               baths: 3,
//               area: '2,500 sq.ft',
//               description: 'This stunning modern villa offers luxurious living with breathtaking ocean views.',
//               propertyType: 'Residential duplex Villa',
//               propertyID: `#PD0785${propertyId}481`,
//               builtYear: '2021'
//             };
//             setSelectedProperty(mockProperty);
//             setCurrentView('edit');
//           } catch (error) {
//             console.error('Failed to fetch property:', error);
//             navigate('/sell-properties');
//           }
//         };
//         fetchProperty();
//       } else {
//         setCurrentView('edit');
//       }
//     } else {
//       if (location.pathname.includes('/inbox')) {
//         setCurrentView('inbox');
//       } else if (location.pathname.includes('/transactions')) {
//         setCurrentView('transactions');
//       } else if (location.pathname.includes('/seeAll')) {
//         setCurrentView('seeAll');
//       } else {
//         setCurrentView('dashboard');
//       }
//     }
//   }, [propertyId, location.pathname, navigate, selectedProperty]);

//   const handleEditProperty = (property) => {
//     setSelectedProperty(property);
//     setCurrentView('edit');
//     navigate(`/sell-properties/edit/${property.id}`, {
//       state: { property }
//     });
//   };

//   const handleSeeAllProperties = () => {
//     setCurrentView('seeAll');
//     navigate('/sell-properties/seeAll');
//   };

//   const handleSidebarNavigation = (itemName) => {
//     if (itemName === 'Inbox') {
//       setCurrentView('inbox');
//       navigate('/sell-properties/inbox');
//     } else if (itemName === 'Dashboard') {
//       setCurrentView('dashboard');
//       navigate('/sell-properties');
//     } else if (itemName === 'Transactions') {
//       setCurrentView('transactions');
//       navigate('/sell-properties/transactions');
//     } else if (itemName === 'My Properties') {
//       setCurrentView('seeAll');
//       navigate('/sell-properties/seeAll');
//     } else if (itemName === 'LogOut') {
//       navigate('/login');
//     } else if (itemName === 'Edit Profile') {
//       // Handle edit profile navigation
//     }
//   };

//   const getActiveSidebarItem = () => {
//     switch (currentView) {
//       case 'inbox':
//         return 'Inbox';
//       case 'dashboard':
//         return 'Dashboard';
//       case 'transactions':
//         return 'Transactions';
//       case 'edit':
//         return 'My Properties';
//       case 'seeAll':
//         return 'My Properties';
//       default:
//         return 'Dashboard';
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         width: '100%',
//         minHeight: '100vh',
//         overflowX: 'hidden',
//         background: '#f9fafb',
//         flexDirection: { xs: 'column', md: 'row' },
//         gap: { xs: '10px', md: 0 },
//         mt: { xs: '64px', md: '15px' },
//       }}
//     >
//       {/* ✅ Profile Verification Dialog - Fixed flickering */}
//       <Dialog
//         open={showVerificationDialog}
//         onClose={(event, reason) => {
//           // Prevent closing on backdrop click or escape key
//           if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
//             return;
//           }
//         }}
//         disableEscapeKeyDown
//         maxWidth="sm"
//         fullWidth
//         keepMounted={false}
//         TransitionProps={{
//           timeout: 300,
//         }}
//         PaperProps={{
//           sx: {
//             borderRadius: '16px',
//             p: 2,
//           }
//         }}
//         slotProps={{
//           backdrop: {
//             sx: {
//               backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             }
//           }
//         }}
//       >
//         <DialogTitle sx={{
//           fontFamily: 'Outfit',
//           fontWeight: 600,
//           fontSize: '24px',
//           pb: 1
//         }}>
//           Complete Your Profile
//         </DialogTitle>

//         <DialogContent>
//           <Typography sx={{
//             fontFamily: 'Outfit',
//             fontSize: '14px',
//             color: '#666',
//             mb: 3
//           }}>
//             Please complete your profile information to continue
//           </Typography>

//           {/* Full Name */}
//           <Box sx={{ mb: 2 }}>
//             <Typography sx={{
//               fontFamily: 'Outfit',
//               fontSize: '14px',
//               fontWeight: 500,
//               mb: 1
//             }}>
//               Full Name <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <TextField
//               fullWidth
//               placeholder="Enter your full name"
//               value={verificationForm.fullName}
//               onChange={(e) => handleVerificationChange('fullName', e.target.value)}
//               error={!!verificationErrors.fullName}
//               helperText={verificationErrors.fullName}
//               disabled={verificationLoading}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Person sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{
//                 '& .MuiInputBase-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit',
//                 }
//               }}
//             />
//           </Box>

//           {/* Email */}
//           <Box sx={{ mb: 2 }}>
//             <Typography sx={{
//               fontFamily: 'Outfit',
//               fontSize: '14px',
//               fontWeight: 500,
//               mb: 1
//             }}>
//               Email Address <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <TextField
//               fullWidth
//               type="email"
//               placeholder="Enter your email"
//               value={verificationForm.email}
//               onChange={(e) => handleVerificationChange('email', e.target.value)}
//               error={!!verificationErrors.email}
//               helperText={verificationErrors.email}
//               disabled={verificationLoading}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Email sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{
//                 '& .MuiInputBase-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit',
//                 }
//               }}
//             />
//           </Box>

//           {/* Mobile Number */}
//           <Box sx={{ mb: 2 }}>
//             <Typography sx={{
//               fontFamily: 'Outfit',
//               fontSize: '14px',
//               fontWeight: 500,
//               mb: 1
//             }}>
//               Mobile Number <span style={{ color: 'red' }}>*</span>
//             </Typography>
//             <TextField
//               fullWidth
//               placeholder="Enter 10-digit mobile number"
//               value={verificationForm.contactNumber}
//               onChange={handlePhoneNumberChange}
//               error={!!verificationErrors.contactNumber}
//               helperText={verificationErrors.contactNumber}
//               disabled={verificationLoading}
//               inputProps={{ maxLength: 10 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Phone sx={{ color: '#666' }} />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{
//                 '& .MuiInputBase-root': {
//                   borderRadius: '8px',
//                   fontFamily: 'Outfit',
//                 }
//               }}
//             />
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3 }}>
//           <Button
//             onClick={handleVerificationSubmit}
//             disabled={verificationLoading}
//             variant="contained"
//             fullWidth
//             sx={{
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               bgcolor: '#0052ff',
//               borderRadius: '8px',
//               py: 1.5,
//               '&:hover': {
//                 bgcolor: '#0041cc',
//               },
//             }}
//           >
//             {verificationLoading ? (
//               <CircularProgress size={24} sx={{ color: 'white' }} />
//             ) : (
//               'Continue'
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {!isMobile && (
//         <Box
//           sx={{
//             flexShrink: 0,
//             width: { xs: '100%', md: 'auto' },
//           }}
//         >
//           <Sidebar
//             userName={profileData?.full_name || user?.fullName || "User"}
//             email={profileData?.email_id || user?.email || ""}
//             phoneNumber={profileData?.contact_number || user?.contactNumber || ""}
//             onItemClick={handleSidebarNavigation}
//             activeItem={getActiveSidebarItem()}
//           />
//         </Box>
//       )}

//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           gap: { xs: '10px', md: '20px' },
//           margin: { xs: '10px', md: '20px' },
//           marginTop: { xs: 0, md: '25px' },
//           boxSizing: 'border-box',
//           overflowX: 'auto',
//         }}
//       >
//         {currentView === 'dashboard' ? (
//           <PropertyDashboard
//             onEditProperty={handleEditProperty}
//             onSeeAllProperties={handleSeeAllProperties}
//           />
//         ) : currentView === 'inbox' ? (
//           <ProfileInbox />
//         ) : currentView === 'transactions' ? (
//           <Transactions />
//         ) : currentView === 'seeAll' ? (
//           <PropertySeeAll onEditProperty={handleEditProperty} />
//         ) : (
//           <EditProperties
//             property={selectedProperty}
//             onBack={() => navigate('/sell-properties')}
//           />
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default SellerProperties;



import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, setUser, setGoogleUser } from '../Commonlibs/userSlice';
import {
  Box,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { Phone, Email, Person } from '@mui/icons-material';
import Sidebar from '../Seller/Sidebar';
import PropertyDashboard from '../Seller/PropertyDashboard';
import EditProperties from '../Seller/EditProperties';
import ProfileInbox from '../Commonlibs/ProfileInbox';
import Transactions from '../Seller/Transactions';
import PropertySeeAll from './PropertySeeAll';

const SellerProperties = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [currentView, setCurrentView] = useState(() => {
    if (propertyId) return 'edit';
    if (location.pathname.includes('/inbox')) return 'inbox';
    if (location.pathname.includes('/transactions')) return 'transactions';
    if (location.pathname.includes('/seeAll')) return 'seeAll';
    return 'dashboard';
  });

  // ✅ Profile verification states
  const [profileData, setProfileData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [showVerificationDialog, setShowVerificationDialog] = useState(false);
  const [verificationForm, setVerificationForm] = useState({
    fullName: '',
    email: '',
    contactNumber: '',
  });
  const [verificationErrors, setVerificationErrors] = useState({});
  const [verificationLoading, setVerificationLoading] = useState(false);

  // ✅ Add refs to prevent multiple fetches and flickering
  const profileFetchedRef = useRef(false);
  const verificationCheckedRef = useRef(false);

  // ✅ Fetch user profile on mount
  useEffect(() => {
    const fetchUserProfile = async () => {
      const userId = user?.id;
      
      if (!userId || profileFetchedRef.current) {
        setLoadingProfile(false);
        return;
      }

      try {
        setLoadingProfile(true);
        profileFetchedRef.current = true;
        
        const response = await fetch(
          `https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`
        );
        const data = await response.json();

        if (data.status === "SUCCESS") {
          setProfileData(data.result);

          if (!verificationCheckedRef.current) {
            verificationCheckedRef.current = true;
            
            const needsVerification =
              !data.result.full_name ||
              data.result.full_name === 'N/A' ||
              data.result.full_name.trim() === '' ||
              !data.result.email_id ||
              data.result.email_id === 'N/A' ||
              data.result.email_id.trim() === '' ||
              !data.result.contact_number ||
              data.result.contact_number === 'N/A' ||
              data.result.contact_number.trim() === '';

            if (needsVerification) {
              setVerificationForm({
                fullName: data.result.full_name && data.result.full_name !== 'N/A' ? data.result.full_name : '',
                email: data.result.email_id && data.result.email_id !== 'N/A' ? data.result.email_id : '',
                contactNumber: data.result.contact_number && data.result.contact_number !== 'N/A' ? data.result.contact_number : '',
              });
              
              setTimeout(() => {
                setShowVerificationDialog(true);
              }, 100);
            }
          }
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
        profileFetchedRef.current = false;
      } finally {
        setLoadingProfile(false);
      }
    };

    fetchUserProfile();
  }, [user?.id]);

  // ✅ Validation function
  const validateVerificationField = (name, value) => {
    if (!value || value.trim() === '' || value === 'N/A') {
      return `${name} is required`;
    }

    switch (name) {
      case 'fullName':
        return /^[A-Za-z\s]{2,50}$/.test(value)
          ? ''
          : 'Name should contain only letters and spaces (2-50 characters)';
      case 'email':
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ''
          : 'Please enter a valid email address';
      case 'contactNumber':
        return /^\d{10}$/.test(value)
          ? ''
          : 'Phone number should be 10 digits';
      default:
        return '';
    }
  };

  // ✅ Handle verification form changes
  const handleVerificationChange = (field, value) => {
    setVerificationForm(prev => ({ ...prev, [field]: value }));
    if (verificationErrors[field]) {
      setVerificationErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // ✅ Handle phone number input (only digits)
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (value === '' || (/^\d+$/.test(value) && value.length <= 10)) {
      handleVerificationChange('contactNumber', value);
    }
  };

  // ✅ Update user profile
  const updateUserProfile = async () => {
    setVerificationLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('user_id', user?.id);
      formDataToSend.append('full_name', verificationForm.fullName);
      formDataToSend.append('email_id', verificationForm.email);
      formDataToSend.append('contact_number', verificationForm.contactNumber);

      const response = await fetch('https://propertydealstalk.com/api/users/UpdateUserprofile', {
        method: 'POST',
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.status === "SUCCESS") {
        setProfileData(data.result);
        setShowVerificationDialog(false);

        const updatedUser = {
          id: data.result.id,
          fullName: data.result.full_name,
          email: data.result.email_id,
          contactNumber: data.result.contact_number,
          token: user?.token,
          authProvider: data.result.auth_provider,
          googleId: data.result.google_id,
          profileImage: data.result.profile_image,
        };

        localStorage.setItem('user_name', data.result.full_name);
        localStorage.setItem('user_email', data.result.email_id);

        if (data.result.auth_provider === 'google') {
          dispatch(setGoogleUser(updatedUser));
        } else {
          dispatch(setUser(updatedUser));
        }
      } else {
        alert(data.message || 'Failed to update profile');
      }
    } catch (error) {
      console.error('Profile update error:', error);
      alert('Failed to update profile. Please try again.');
    } finally {
      setVerificationLoading(false);
    }
  };

  // ✅ Handle verification submit
  const handleVerificationSubmit = async () => {
    const newErrors = {};
    Object.keys(verificationForm).forEach(key => {
      const error = validateVerificationField(key, verificationForm[key]);
      if (error) newErrors[key] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      setVerificationErrors(newErrors);
      return;
    }

    await updateUserProfile();
  };

  // ✅ FIXED: Simplified property management logic
  useEffect(() => {
    if (propertyId) {
      setCurrentView('edit');
    } else {
      if (location.pathname.includes('/inbox')) {
        setCurrentView('inbox');
      } else if (location.pathname.includes('/transactions')) {
        setCurrentView('transactions');
      } else if (location.pathname.includes('/seeAll')) {
        setCurrentView('seeAll');
      } else {
        setCurrentView('dashboard');
      }
    }
  }, [propertyId, location.pathname]);

  const handleEditProperty = (property) => {
    navigate(`/sell-properties/edit/${property.id}`);
  };

  const handleSeeAllProperties = () => {
    setCurrentView('seeAll');
    navigate('/sell-properties/seeAll');
  };

  const handleSidebarNavigation = (itemName) => {
    if (itemName === 'Inbox') {
      setCurrentView('inbox');
      navigate('/sell-properties/inbox');
    } else if (itemName === 'Dashboard') {
      setCurrentView('dashboard');
      navigate('/sell-properties');
    } else if (itemName === 'Transactions') {
      setCurrentView('transactions');
      navigate('/sell-properties/transactions');
    } else if (itemName === 'My Properties') {
      setCurrentView('seeAll');
      navigate('/sell-properties/seeAll');
    } else if (itemName === 'LogOut') {
      navigate('/login');
    } else if (itemName === 'Edit Profile') {
      // Handle edit profile navigation
    }
  };

  const getActiveSidebarItem = () => {
    switch (currentView) {
      case 'inbox':
        return 'Inbox';
      case 'dashboard':
        return 'Dashboard';
      case 'transactions':
        return 'Transactions';
      case 'edit':
        return 'My Properties';
      case 'seeAll':
        return 'My Properties';
      default:
        return 'Dashboard';
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        overflowX: 'hidden',
        background: '#f9fafb',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '10px', md: 0 },
        mt: { xs: '64px', md: '15px' },
      }}
    >
      {/* Profile Verification Dialog */}
      <Dialog
        open={showVerificationDialog}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
        }}
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
        keepMounted={false}
        TransitionProps={{ timeout: 300 }}
        PaperProps={{
          sx: { borderRadius: '16px', p: 2 }
        }}
        slotProps={{
          backdrop: {
            sx: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
          }
        }}
      >
        <DialogTitle sx={{
          fontFamily: 'Outfit',
          fontWeight: 600,
          fontSize: '24px',
          pb: 1
        }}>
          Complete Your Profile
        </DialogTitle>

        <DialogContent>
          <Typography sx={{
            fontFamily: 'Outfit',
            fontSize: '14px',
            color: '#666',
            mb: 3
          }}>
            Please complete your profile information to continue
          </Typography>

          {/* Full Name */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Full Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter your full name"
              value={verificationForm.fullName}
              onChange={(e) => handleVerificationChange('fullName', e.target.value)}
              error={!!verificationErrors.fullName}
              helperText={verificationErrors.fullName}
              disabled={verificationLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>

          {/* Email */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Email Address <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              type="email"
              placeholder="Enter your email"
              value={verificationForm.email}
              onChange={(e) => handleVerificationChange('email', e.target.value)}
              error={!!verificationErrors.email}
              helperText={verificationErrors.email}
              disabled={verificationLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>

          {/* Mobile Number */}
          <Box sx={{ mb: 2 }}>
            <Typography sx={{
              fontFamily: 'Outfit',
              fontSize: '14px',
              fontWeight: 500,
              mb: 1
            }}>
              Mobile Number <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter 10-digit mobile number"
              value={verificationForm.contactNumber}
              onChange={handlePhoneNumberChange}
              error={!!verificationErrors.contactNumber}
              helperText={verificationErrors.contactNumber}
              disabled={verificationLoading}
              inputProps={{ maxLength: 10 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Phone sx={{ color: '#666' }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  fontFamily: 'Outfit',
                }
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={handleVerificationSubmit}
            disabled={verificationLoading}
            variant="contained"
            fullWidth
            sx={{
              textTransform: 'none',
              fontFamily: 'Outfit',
              bgcolor: '#0052ff',
              borderRadius: '8px',
              py: 1.5,
              '&:hover': {
                bgcolor: '#0041cc',
              },
            }}
          >
            {verificationLoading ? (
              <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
              'Continue'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {!isMobile && (
        <Box
          sx={{
            flexShrink: 0,
            width: { xs: '100%', md: 'auto' },
          }}
        >
          <Sidebar
            userName={profileData?.full_name || user?.fullName || "User"}
            email={profileData?.email_id || user?.email || ""}
            phoneNumber={profileData?.contact_number || user?.contactNumber || ""}
            onItemClick={handleSidebarNavigation}
            activeItem={getActiveSidebarItem()}
          />
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: '10px', md: '20px' },
          margin: { xs: '10px', md: '20px' },
          marginTop: { xs: 0, md: '25px' },
          boxSizing: 'border-box',
          overflowX: 'auto',
        }}
      >
        {currentView === 'dashboard' ? (
          <PropertyDashboard
            onEditProperty={handleEditProperty}
            onSeeAllProperties={handleSeeAllProperties}
          />
        ) : currentView === 'inbox' ? (
          <ProfileInbox />
        ) : currentView === 'transactions' ? (
          <Transactions />
        ) : currentView === 'seeAll' ? (
          <PropertySeeAll onEditProperty={handleEditProperty} />
        ) : (
          <EditProperties />
        )}
      </Box>
    </Box>
  );
};

export default SellerProperties;
